module.exports = __webpack_public_path__ + "static/media/banner.eabd5ec2.jpg";